import { render, staticRenderFns } from "./OfficeTimeTrackerView.vue?vue&type=template&id=a85fa904&scoped=true"
import script from "./OfficeTimeTrackerView.vue?vue&type=script&lang=js"
export * from "./OfficeTimeTrackerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85fa904",
  null
  
)

export default component.exports